export const Constants = {
  priorities: ['1', '2', '3', '4', '5', '6']
};
